export default __webpack_public_path__ + "static/media/Image7.b8651af5.png";